
import { LandingPage, Product } from '../types';

const STORAGE_KEY = 'lynqar_landing_pages';

export const landingPageService = {
  getStoreLPs: (storeId: string): LandingPage[] => {
    const data = localStorage.getItem(STORAGE_KEY);
    const all: LandingPage[] = data ? JSON.parse(data) : [];
    return all.filter(lp => lp.storeId === storeId);
  },

  getLPBySlug: (slug: string): LandingPage | null => {
    const data = localStorage.getItem(STORAGE_KEY);
    const all: LandingPage[] = data ? JSON.parse(data) : [];
    return all.find(lp => lp.slug === slug && lp.status === 'PUBLISHED') || null;
  },

  saveLP: (lp: LandingPage) => {
    const data = localStorage.getItem(STORAGE_KEY);
    let all: LandingPage[] = data ? JSON.parse(data) : [];
    const idx = all.findIndex(item => item.id === lp.id);
    if (idx !== -1) all[idx] = lp;
    else all.push(lp);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
  },

  deleteLP: (id: string) => {
    const data = localStorage.getItem(STORAGE_KEY);
    if (!data) return;
    const all: LandingPage[] = JSON.parse(data);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all.filter(lp => lp.id !== id)));
  },

  trackView: (id: string) => {
    const data = localStorage.getItem(STORAGE_KEY);
    if (!data) return;
    const all: LandingPage[] = JSON.parse(data);
    const updated = all.map(lp => lp.id === id ? { ...lp, views: lp.views + 1 } : lp);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  },

  trackConversion: (id: string) => {
    const data = localStorage.getItem(STORAGE_KEY);
    if (!data) return;
    const all: LandingPage[] = JSON.parse(data);
    const updated = all.map(lp => lp.id === id ? { ...lp, conversions: lp.conversions + 1 } : lp);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  }
};
